import { render } from "./configModal.vue?vue&type=template&id=c6cd300e&scoped=true"
import script from "./configModal.vue?vue&type=script&lang=js"
export * from "./configModal.vue?vue&type=script&lang=js"

import "./configModal.vue?vue&type=style&index=0&id=c6cd300e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cd300e"]])

export default __exports__